import React from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {Image, ScrollView, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import ChevronDroitMediumPicto from "../Picto/ChevronDroitMediumPicto";

class ReglageConfidentialiteScreen extends React.Component{
    constructor(props) {
        super(props);
        this.navigateToNIP = this.navigateToNIP.bind(this);
    }

    componentDidMount() {
        this._setHeader();
    }

    componentDidUpdate() {
        this._setHeader();
    }

    _setHeader(){
        const styleHeaderGlobalWhite = {
            fontFamily: this.props.theme.fonts.title,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        this.props.navigation.setOptions(
            {
                headerTitleAlign: "center",
                headerStyle: styleHeaderGlobalWhite,
                headerTitleStyle:{textTransform: 'capitalize'},
                title : this.props.t('Confidentialité'),
                headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,height: 20,marginLeft:20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                </TouchableOpacity>
            }
        );
    }

    navigateToNIP(){
        this.props.navigation.navigate("NIP",{isChange:true});
    }

    render() {
        const styles= StyleSheet.create({
            container:{
                paddingVertical:12,
                paddingHorizontal:20,
                flexDirection:"row",
                justifyContent:"space-between",
                alignItems:"center",
                borderBottomWidth:1,
                borderBottomColor:this.props.theme.colors.tertiary.black13.value,
                backgroundColor:this.props.theme.colors.primary.White.value
            } ,
            container_title:{
                backgroundColor:this.props.theme.colors.primary.blue5.value,
                color:this.props.theme.colors.primary.blue1.value
            },
            text:{
                fontFamily:this.props.theme.fonts.text_bold,
                color : this.props.theme.colors.tertiary.black3.value,
                fontSize:15,
                fontWeight:500
            },
            text_title:{
                color:this.props.theme.colors.primary.blue1.value
            },
            picto:{
                width:10,
                marginRight:10
            }
        });
        return (
            <ScrollView>
                <TouchableOpacity >
                    <View style={[styles.container,styles.container_title]}>
                        <Text style={[styles.text,styles.text_title]}>{this.props.t("NIP")}</Text>
                    </View>
                </TouchableOpacity>
                <TouchableOpacity onPress={this.navigateToNIP} >
                    <View style={styles.container}>
                        <Text style={styles.text}>{this.props.t("Changer votre NIP")}</Text>
                        <ChevronDroitMediumPicto style={styles.picto} isHeader={true} />
                    </View>
                </TouchableOpacity>
            </ScrollView>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(ReglageConfidentialiteScreen);
